// Rutas de pantallas de la aplicación, para sugerirlas al crear o editar una opción del menú.
// Generado desde src/routes/AppRoutes.jsx (path="..."). Si agregas una pantalla nueva, añade aquí su ruta
// (el campo de ruta del menú también acepta cualquier texto, ej.: /embed/nombre).
const RUTAS_CONOCIDAS = [
  "/admin",
  "/administracion-personal",
  "/administracion-personal/detalle",
  "/caja-chica",
  "/caja-chica-el-alto",
  "/caja-general",
  "/caja-instalacion",
  "/caja-proyectos",
  "/caja-tecnica",
  "/caja-viatico",
  "/calendario",
  "/centro-equipos",
  "/chatbot",
  "/cliente-servicio",
  "/clientes",
  "/clients",
  "/comparador-plataformas",
  "/configuracion",
  "/dashboard",
  "/dashboard-facturacion",
  "/documentacion",
  "/documentos",
  "/egresos",
  "/extracto-historico",
  "/factura-manual",
  "/facturacion",
  "/facturacion-admin",
  "/flespi",
  "/historial-cliente",
  "/inventario-interno",
  "/leasecontrol",
  "/mi-cuenta",
  "/mis-clientes",
  "/notas",
  "/noticias",
  "/notificaciones",
  "/ordenes-compra",
  "/orden-de-trabajo",
  "/pago-masivo",
  "/panel-global",
  "/permisos/calendario",
  "/permisos/mis-solicitudes",
  "/permisos/solicitudes",
  "/programacion-equipo",
  "/proyectos",
  "/reclamos",
  "/registro-equipos",
  "/reporte-cierre",
  "/reporte-cliente",
  "/reporte-facturas",
  "/reporte-impuestos",
  "/reporte-libro-ventas",
  "/reporte-pagos",
  "/requerimiento",
  "/revision-plataformas",
  "/solicitud-cheque",
  "/telusgy/leads",
  "/telusgy/productos",
  "/telusgy/proyectos",
  "/tipo-cambio",
  "/traspaso-equipos",
  "/trsrastreo",
  "/users",
  "/vehiculos",
  "/vencimientos",
  "/wialon"
];

export default RUTAS_CONOCIDAS;
